import type { Routes } from '@angular/router';

import { RoutePath } from '@malou-io/package-utils';

import { INSPIRATIONS_ROUTES } from '#modules/inspirations/routes/inspirations.routing';
import { SOCIAL_POSTS_ROUTES } from '#modules/posts/routes/social-posts.routing';
import { STORIES_ROUTES } from '#modules/posts/routes/stories.routing';

export const SOCIAL_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#shell/layouts/logged-in-layout/restaurants/social-layout/social-layout.component').then(
                (m) => m.SocialLayoutComponent
            ),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'socialposts',
            },
            {
                path: 'socialposts',
                loadChildren: () => SOCIAL_POSTS_ROUTES,
                data: { routePath: RoutePath.SOCIAL_POSTS },
            },
            {
                path: 'stories',
                loadChildren: () => STORIES_ROUTES,
                data: { routePath: RoutePath.STORIES },
            },
            {
                path: 'inspirations',
                loadChildren: () => INSPIRATIONS_ROUTES,
                data: { routePath: RoutePath.INSPIRATIONS },
            },
        ],
    },
];
